import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import PublicRoute from './routes/PublicRoute';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ChantiersList from './components/ChantiersList';
import InvitePage from './components/InvitePage';
import GuidePage from './components/GuidePage';
import AppLayout from './layout/AppLayout';
import './App.css';

// L'outil de dessin (MyDraft, ~450 ko) n'est chargé qu'à l'ouverture d'un plan.
const PlanEditorPage = lazy(() => import('./components/PlanEditorPage'));

function AppRoutes() {
  const { initialized } = useAuth();

  if (!initialized) {
    return (
      <div className="App">
        <p className="App-loading">Chargement…</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/invite/:code" element={<InvitePage />} />

      <Route element={<ProtectedRoute />}>
        {/* écrans connectés : menu général commun */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<ChantiersList />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route
            path="/chantiers/:id/plan"
            element={
              <Suspense fallback={<p className="App-loading">Chargement de l'outil de dessin…</p>}>
                <PlanEditorPage />
              </Suspense>
            }
          />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
